import React, { FC } from "react";
import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { useSaleOrderDetailModel } from "./saleOrderDetailModel";
import { Description } from "@/components/YhBox/Description";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { useDictModel } from "../../../../../base/dict/dictModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
import { useSaleOrderModel } from "../../saleOrderModel";

interface ITopType {
    id: string,
    mode: "add" | "edit" | "look",
    IYhFormRef: React.MutableRefObject<IYhFormRef | undefined>
}
export const TopButs: FC<ITopType> = ({ id, mode, IYhFormRef }) => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale,language } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const { setSelectedRowKeys,setDescRows,setSelectedRow } = useSaleOrderModel()
    const { detailAddForm, detailLookForm, detailAddList, detailEditForm, insertDetail, editDetail, resetAddCatch, getDetailEditOne, setDetailAddForm, setDetailAddList } = useSaleOrderDetailModel();
    const { selectedNavId, replaceNav } = useNavModel();
    const { getTreeNodeOne } = useDictModel();
    const save = async () => {
        IYhFormRef.current?.validateFields().then(async res => {
            if (mode == "add") {
                if (detailAddList.length == 0) { return globalPrompt("message", { text: Locale["Please add material details."], type: "error" }); }
                const resData = await insertDetail(res)
                if (resData) {
                    goBack();
                    globalPrompt("message", { text: Locale["Successfully added"], type: "success" });
                    resetAddCatch(mode)
                    setSelectedRowKeys([resData.id as string])
                    setDescRows([resData])
                    setSelectedRow(resData)
                }
            } else if (mode == "edit") {
                let { saleOrderCode, id } = detailEditForm
                const resData = await editDetail({ ...res, saleOrderCode, id })
                resData == true && goBack() && globalPrompt("message", { text:  Locale["Successfully edited"], type: "success" })
            }
        })
    }
    const goBack = async () => {
        replaceNav(selectedNavId, "2-6")
    }
    const onRefresh = async () => {
        if (mode == 'add') {
            IYhFormRef.current?.resetFields()
            setDetailAddForm({ favorableAmount: 0, discountRate: 100 })
            setDetailAddList([])

        } else if (mode == 'edit') {
            getDetailEditOne(id, mode)
        }
        message.success(Locale["Successfully refreshed"])
    }
    const action = <>
        {mode != "look" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => save()}
        >{Locale["Save"]}</Button>}
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => goBack()}
        >{Locale["Back"]}</Button>
        {mode != "look" && <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => onRefresh()}
        >{Locale["Refresh"]}</Button>}

    </>;

    const typeTitle = {
        "add": detailAddForm,
        "edit": detailEditForm,
        "look": detailLookForm,
    }
    const orderStatu: IDescription[] = [
        {
            label: Locale["Sales Order No."], //"销售单",
            value: typeTitle[mode]?.saleOrderCode as string ?? Locale["Not yet"],
            color: DescriptionColorEnum.blue,
            status: true
        },
        {
            label: Locale["Status"],//"状态",
            // value: (typeTitle[mode]?.status && getTreeNodeName(typeTitle[mode]?.status as string)) ?? Locale["Not yet"],
            value: (typeTitle[mode]?.status && (language == "zh-CN" ? getTreeNodeOne(typeTitle[mode]?.status as string)[0].name : getTreeNodeOne(typeTitle[mode]?.status as string)[0].nameEn as string)) ?? Locale["Not yet"],
            color: DescriptionColorEnum.green,
            status: true
        }
    ]

    return (
        <YhBox title={<>
            {orderStatu.map((item, index) => <Description key={index} {...item} />)}
        </>}
            action={action}
            style={{ paddingBottom: 0, marginBottom: "15px" }}
        />
    )
}